import { SYSTableDefIds } from "../../../.."
import { columnFilter } from "./columnfilter/state"
let tableDefIdPerDialog: { [key: string]: SYSTableDefIds } = {}
let filterSort = {
  fieldToUpdate: {
    formType: "",
    formId: "",
    fieldKey: "",
  },
  currentFilterSortSettings: "",
  currentTableDefId: "",
  tableDefIdPerDialog,
  // these are simple array result lookups which will be used in list type getlist and reduced to nice form
  // they will only contain valid data (acoording permissions)
  lookups: {
    CardCode: undefined,
    U_CntctCode: undefined,
  },
}
export let SYSTableSettingsState = { filterSort, columnFilter }
